module.exports = __webpack_public_path__ + "./assets/icons/top-5-programming-languages-hero1579801696278282.jpg";